
// export type PaymentMethod = 'card' | 'google-pay' | 'apple-pay';

export enum PaymentMethod {
    CARD = 'card',
    GOOGLE_PAY = 'google-pay',
    APPLE_PAY = 'apple-pay',
    LINK = 'link'
}